import { Component } from '@angular/core';

import { AlertService } from '../../../_services/services'
import { MaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared.module';

@Component({
    selector: 'alert-message',
    templateUrl: 'alert.component.html',
    standalone: true, // Required for Angular 18's new standalone components
    imports: [
        SharedModule,
        MaterialModule
    ]
})

export class AlertMessageComponent {
    messages: any = [];

    constructor(private alertService: AlertService) { }

    ngOnInit() {
        this.alertService.getMessage().subscribe(message => {

            if (message == undefined) {

                this.messages = [];
            }
            else if (message.isClear) {

                this.messages = this.messages.filter(
                    m => m.id != message.id);
            }
            else if (message.isAppended) {

                this.messages.push(message);
            }
            else {

                this.messages = [];
                this.messages.push(message);
            }
        });
    }
    close(message) {
        message.text = '';
        this.alertService.clear();
    }
}